<!-- body wrapper  -->
<div class="body-wrapper">

    <!-- ==========page banner ========== -->
    <div class="page-ban">
        <div class="page-ban-inner">
            <div class="container">
                <div class="page-content">
                    <h2 class="page-title">
                        Customer Testimonial
                    </h2>
                    <div class="page-url">
                        <a routerLink="/" class="old-page">Home </a> /
                        <p>Customer Testimonial</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- ==========page banner end ====== -->

    <!-- =============News & Events========== -->
    <section>
        <div class="latest-blog cpy-8">
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="sec-title">
                        <div class="col-lg-8 col-md-8 col-sm-10">
                            <div class="sec-head">
                                <h2 class="mb-2">Customer Testimonial</h2>
                                <p class="mb-2">
                                    At <span class="fw-bold theme-color">Prism Textile Machinery</span>, we take pride
                                    in delivering reliable weaving, dyeing, and finishing solutions. Our focus on
                                    quality and service ensures our customers achieve the best performance and
                                    efficiency in denim fabric production.
                                </p>

                                <p>
                                    With <span class="fw-bold theme-color">Prism Textile Machinery</span>, innovation
                                    meets dependability. Our weaving, dyeing, and finishing machines are built to
                                    deliver consistent results, backed by a team dedicated to customer success.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center mt-4 pt-5">
                    <div class="col-lg-10 col-md-10 col-sm-12 col-12">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4"
                                *ngFor="let testimonial of customerTestimonialList; let i = index;">
                                <a [href]="testimonial?.pdf" target="_blank">
                                    <div class="pdf-box text-center">
                                        <div class="pdf-header-content">
                                            <p class="m-0 font-14">{{ testimonial.title }}</p>
                                        </div>
                                        <div class="pdf-body-content">
                                            <img src="assets/img/pdf-satisfaction.png" alt="" class="img-fluid pdf-img">
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>